import type { ClassroomBody } from '@innovamat/glow-api-client';
import { useManageClassrooms } from '../../../../classrooms-management/hooks/use-manage-classrooms';
import type { Classroom } from '../../../../classrooms-management/modules/classroom';
import { useCurrentNavigationValues } from '../../../../navigation/hooks/use-current-navigation-values';

type UseKnowMoreDrawer = {
  classroom: Classroom | undefined;
  isModifyModalOpen: boolean;
  handleCloseModifyModal: () => void;
  handleModalSuccess: (classroomBody: ClassroomBody) => void;
  handleOpenModifyModal: () => void;
};

function useKnowMoreDrawer(): UseKnowMoreDrawer {
  const { currentClassroom } = useCurrentNavigationValues();
  const { editModalData, handleOnEditSuccess, openEditModal } =
    useManageClassrooms();

  const handleOpenModifyModal = (): void => {
    if (currentClassroom) {
      openEditModal(currentClassroom);
    }
  };

  const handleCloseModifyModal = (): void => {
    openEditModal(undefined);
  };

  const handleModalSuccess = (classroomBody: ClassroomBody): void => {
    handleOnEditSuccess({
      ...currentClassroom,
      ...classroomBody,
    } as Classroom);
    handleCloseModifyModal();
  };

  return {
    isModifyModalOpen: editModalData.show,
    classroom: currentClassroom,
    handleOpenModifyModal,
    handleCloseModifyModal,
    handleModalSuccess,
  };
}

export { useKnowMoreDrawer };
